// web-common/src/drafts.js — the DRAFTS + BRANDS client (CREATE-1 §9): thin, typed-by-test
// wrappers over the product-layer routes. The app's Create flow uses THESE (the product
// door — the server builds the seam commands from the draft/brand rows); the raw seam
// builders (commands.js buildIdeate/buildScript) serve the bench/suites/API examples.
//
// Every function takes the api client (web-common/src/api.js makeApi) first and returns
// its CLASSIFIED result ({ kind: 'ok' | 'needs_confirm' | 'insufficient_credits' |
// 'refused' | 'invalid' | 'auth' | 'error', ... } — errors.js) — screens switch on kind,
// exactly like the render flow.
//
// The idempotency rule holds here too: mint ONE key per user intent (the button press),
// reuse it for retries of that intent; a NEW intent mints a NEW key.

// ---- drafts ----
export async function listDrafts(api, { limit } = {}) {
  return api.get('drafts' + (limit ? `?limit=${encodeURIComponent(limit)}` : ''));
}
export async function createDraft(api, { prompt = '', settings = null, brandId = null } = {}) {
  return api.post('drafts', { prompt, ...(settings ? { settings } : {}), ...(brandId ? { brand_id: brandId } : {}) });
}
export async function getDraft(api, id) {
  return api.get(`drafts/${encodeURIComponent(id)}`);
}
export async function updateDraft(api, id, patch) {
  return api.patch(`drafts/${encodeURIComponent(id)}`, patch || {});
}
export async function archiveDraft(api, id) {
  return api.patch(`drafts/${encodeURIComponent(id)}`, { archived: true });
}

// ---- the authoring verbs, through the draft (quote_only -> price; confirm -> spend) ----
export async function draftIdeate(api, id, { steer = null, quoteOnly = false, confirm = false, idempotencyKey = null } = {}) {
  return api.post(`drafts/${encodeURIComponent(id)}/ideate`,
    { ...(steer ? { steer } : {}), ...(quoteOnly ? { quote_only: true } : {}), ...(confirm ? { confirm: true } : {}) },
    idempotencyKey ? { idempotencyKey } : {});
}
export async function draftScript(api, id, { setJobId = null, cardId = null, steer = null, quoteOnly = false, confirm = false, idempotencyKey = null } = {}) {
  return api.post(`drafts/${encodeURIComponent(id)}/script`,
    { ...(setJobId ? { set_job_id: setJobId } : {}), ...(cardId ? { card_id: cardId } : {}),
      ...(steer ? { steer } : {}), ...(quoteOnly ? { quote_only: true } : {}), ...(confirm ? { confirm: true } : {}) },
    idempotencyKey ? { idempotencyKey } : {});
}
// approve: the USER'S OWN genblocks from the draft — mode:'live' by default everywhere;
// `mode:'mock'` is honored ONLY by the dev rig (QS_ALLOW_MOCK_CREATE=1), never in prod.
export async function draftApprove(api, id, { quoteOnly = false, confirm = false, mode = null, idempotencyKey = null } = {}) {
  return api.post(`drafts/${encodeURIComponent(id)}/approve`,
    { ...(quoteOnly ? { quote_only: true } : {}), ...(confirm ? { confirm: true } : {}), ...(mode ? { mode } : {}) },
    idempotencyKey ? { idempotencyKey } : {});
}

// ---- brands ----
export async function listBrands(api) {
  return api.get('brands');
}
export async function createBrand(api, brand) {
  return api.post('brands', brand);
}
export async function getBrand(api, id) {
  return api.get(`brands/${encodeURIComponent(id)}`);
}
export async function updateBrand(api, id, brand) {
  return api.put(`brands/${encodeURIComponent(id)}`, brand);
}
export async function deleteBrand(api, id) {
  return api.del(`brands/${encodeURIComponent(id)}`);
}
// save-as-brand's prefill (confirm-not-create): derive the form's starting values from a
// finished run's genome; saving is the normal createBrand with the user's edits.
export async function brandPrefill(api, runId) {
  return api.get(`runs/${encodeURIComponent(runId)}/brand-prefill`);
}
